import cornerstoneTools from "cornerstone-tools";


const BaseAnnotationTool = cornerstoneTools.importInternal('base/BaseAnnotationTool');

const external = cornerstoneTools.external;


const draw = cornerstoneTools.importInternal('drawing/draw');
const drawLine = cornerstoneTools.importInternal('drawing/drawLine');
const setShadow = cornerstoneTools.importInternal('drawing/setShadow');
const getNewContext = cornerstoneTools.importInternal('drawing/getNewContext');
const drawTextBox = cornerstoneTools.importInternal('drawing/drawTextBox');

const getToolState = cornerstoneTools.getToolState;
//const toolStyle = cornerstoneTools.toolStyle
const getModule = cornerstoneTools.getModule;


const lineSegDistance = cornerstoneTools.importInternal('util/lineSegDistance');
const getPixelSpacing = cornerstoneTools.importInternal('util/getPixelSpacing');
const throttle = cornerstoneTools.importInternal('util/throttle');
const lengthCursor = cornerstoneTools.importInternal('cursors/index');

/**
 * @public
 * @class LineTool
 * @memberof Tools.Annotation
 * @classdesc Tool for measuring distances.
 * @extends Tools.Base.BaseAnnotationTool
 */
export default class SquareGrid extends BaseAnnotationTool {
  constructor(props = {}) {
    const defaultProps = {
      name: 'SquareGrid',
      supportedInteractionTypes: [],
      svgCursor: lengthCursor,
      configuration: {
        drawHandles: true,
        drawHandlesOnHover: false,
        hideHandlesIfMoving: false,
        renderDashed: false,
        digits: 2,
      },
    };

    super(props, defaultProps);

    this.throttledUpdateCachedStats = throttle(this.updateCachedStats, 110);
  }

  createNewMeasurement(eventData) {
    const goodEventData =
      eventData && eventData.currentPoints && eventData.currentPoints.image;

    if (!goodEventData) {
      

      return;
    }

    const { x, y } = eventData.currentPoints.image;

    return {
      visible: true,
      active: true,
      color: undefined,
      invalidated: true,
      handles: {
        start: {
          x,
          y,
          highlight: true,
          active: false,
        },
        end: {
          x,
          y,
          highlight: true,
          active: true,
        },
        textBox: {
          active: false,
          hasMoved: false,
          movesIndependently: false,
          drawnIndependently: true,
          allowedOutsideImage: true,
          hasBoundingBox: true,
        },
      },
    };
  }

  /**
   *
   *
   * @param {*} element
   * @param {*} data
   * @param {*} coords
   * @returns {Boolean}
   */
  pointNearTool(element, data, coords) {
    const hasStartAndEndHandles =
      data && data.handles && data.handles.start && data.handles.end;
    const validParameters = hasStartAndEndHandles;

    if (!validParameters) {
      
      return false;
    }

    if (data.visible === false) {
      return false;
    }

    return (
      lineSegDistance(element, data.handles.start, data.handles.end, coords) <
      25
    );
  }

  updateCachedStats(image, element, data) {
    const { rowPixelSpacing, colPixelSpacing } = getPixelSpacing(image);

    // Set rowPixelSpacing and columnPixelSpacing to 1 if they are undefined (or zero)
    const dx =
      (data.handles.end.x - data.handles.start.x) * (colPixelSpacing || 1);
    const dy =
      (data.handles.end.y - data.handles.start.y) * (rowPixelSpacing || 1);

    // Calculate the length, and create the text variable with the millimeters or pixels suffix
    const length = Math.sqrt(dx * dx + dy * dy);

    // Store the length inside the tool for outside access
    data.length = length;
    data.invalidated = false;
  }

  renderToolData(evt) {
    const eventData = evt.detail;
    const {
      renderDashed,
    } = this.configuration;
    const toolData = getToolState(evt.currentTarget, this.name);
    console.log(toolData)
    if (!toolData) {
      return;
    }

    // We have tool data for this element - iterate over each one and draw it
    const context = getNewContext(eventData.canvasContext.canvas);
    const { element } = eventData;
    //const { rowPixelSpacing, colPixelSpacing } = getPixelSpacing(image);

    //const lineWidth = toolStyle.getToolWidth();
    const lineDash = getModule('globalConfiguration').configuration.lineDash;

    for (let i = 0; i < toolData.data.length; i++) {
      const data = toolData.data[i];

      draw(context, context => {
        // Configurable shadow
        setShadow(context, this.configuration);

        const color = "#000000" //toolColors.getColorIfActive(data);
        const size = 20;
        //console.log(color)
        const lineOptions = { color, size };

        if (renderDashed) {
          lineOptions.lineDash = lineDash;
        }

        console.log("wilidnsf-dfiks---------")

        data.lines.horizontal.map(item => {
          // Draw the measurement line
        drawLine(
          context,
          element,
          item.start,
          item.end,
          lineOptions
        );
        })
        
        data.lines.vertical.map(item => {
          // Draw the measurement line
        drawLine(
          context,
          element,
          item.start,
          item.end,
          lineOptions
        );
        })
        
        
      });
    }

 
  }
}